import React, { ReactNode } from 'react';
import { usePullToRefresh } from '@/hooks/use-pull-to-refresh';
import { PullToRefreshIndicator } from '@/components/ui/pull-to-refresh-indicator';

interface PullToRefreshWrapperProps {
  children: ReactNode;
  refreshQueries: string[];
  onRefresh?: () => Promise<void> | void;
  className?: string;
}

export function PullToRefreshWrapper({
  children,
  refreshQueries,
  onRefresh,
  className = ''
}: PullToRefreshWrapperProps) {
  const {
    containerRef,
    isPulling,
    isRefreshing,
    pullDistance,
    contentStyle,
    refreshIndicatorStyle
  } = usePullToRefresh({
    refreshQueries,
    onRefresh
  });

  return (
    <div 
      ref={containerRef}
      className={`relative h-full overflow-hidden ${className}`}
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {/* Container per l'indicator che occupa spazio in alto */}
      <PullToRefreshIndicator
        isPulling={isPulling}
        isRefreshing={isRefreshing}
        pullDistance={pullDistance}
        style={refreshIndicatorStyle}
      />
      {/* Contenuto che scorre verso il basso */}
      <div 
        className="h-full overflow-y-auto"
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
}
